class BaseSlider extends HTMLElement {
  constructor() {
    super();

    this.dataId = this.getAttribute('data-id');
    this.slideCount = this.getAttribute('data-slidecount') || 0;
  }

  connectedCallback() {
    this.initSwiper();
  }

  disconnectedCallback() {
    this.destroySwiper();
  }

  showContainer() {
    this.classList.remove('opacity-0');
  }

  initSwiper() {
    if (this.slideCount === 1) {
      console.info('Swiper not initialized. Only one child element.');
      this.showContainer();

      return null;
    }

    const paginationId = `swiper-pagination-${this.dataId}`;

    const paginationEnabled = {
      pagination: {
        el: `#${paginationId}`,
        type: 'bullets',
        clickable: true,
      },
    };

    this.swiperInstance = new Swiper(this, {
      slidesPerView: 1,
      autoHeight: true,
      preventInteractionOnTransition: true,
      on: {
        init: () => this.showContainer(),
      },
      ...paginationEnabled,
    });
  }

  destroySwiper() {
    if (this.swiperInstance) {
      try {
        if (this.swiperInstance.destroyed) {
          console.info('Swiper already destroyed');

          this.swiperInstance = null;

          return null;
        }

        this.swiperInstance.destroy(true, true);
        this.swiperInstance = null;
      } catch (error) {
        console.error('Error destroying Swiper:', error);

        this.swiperInstance = null; // Fallback
      }
    } else {
      console.log('No Swiper instance to destroy');
    }
  }
}
